export const types = {
    GET_SUBSCRIPTION_PLANS: 'GET_SUBSCRIPTION_PLANS',
    GET_SUBSCRIPTION_PLANS_SUCCESS: 'GET_SUBSCRIPTION_PLANS_SUCCESS',
    GET_SUBSCRIPTION_PLANS_FAIL: 'GET_SUBSCRIPTION_PLANS_FAIL',
    SUBSCRIBE: 'SUBSCRIBE',
    SUBSCRIBE_SUCCESS: 'SUBSCRIBE_SUCCESS',
    SUBSCRIBE_FAIL: 'SUBSCRIBE_FAIL',
    CANCEL_SUBSCRIPTION: 'CANCEL_SUBSCRIPTION',
    CANCEL_SUBSCRIPTION_SUCCESS: 'CANCEL_SUBSCRIPTION_SUCCESS',
    CANCEL_SUBSCRIPTION_FAIL: 'CANCEL_SUBSCRIPTION_FAIL',
    GET_SUBSCRIPTION: 'GET_SUBSCRIPTION',
    GET_SUBSCRIPTION_SUCCESS: 'GET_SUBSCRIPTION_SUCCESS',
    GET_SUBSCRIPTION_FAIL: 'GET_SUBSCRIPTION_FAIL',
    UPDATE_SUBSCRIPTION: 'UPDATE_SUBSCRIPTION',
    UPDATE_SUBSCRIPTION_SUCCESS: 'UPDATE_SUBSCRIPTION_SUCCESS',
    UPDATE_SUBSCRIPTION_FAIL: 'UPDATE_SUBSCRIPTION_FAIL',
    SET_SUBSCRIPTION: 'SET_SUBSCRIPTION',
    SET_SUBSCRIPTION_SUCCESS: 'SET_SUBSCRIPTION_SUCCESS',
    SET_SUBSCRIPTION_FAIL: 'SET_SUBSCRIPTION_FAIL',
    RESET_SUBSCRIPTION_DATA: 'RESET_SUBSCRIPTION_DATA',
    INITIALIZE_PAYSTACK_SUBSCRIPTION: 'INITIALIZE_PAYSTACK_SUBSCRIPTION',
    INITIALIZE_PAYSTACK_SUBSCRIPTION_SUCCESS: 'INITIALIZE_PAYSTACK_SUBSCRIPTION_SUCCESS',
    INITIALIZE_PAYSTACK_SUBSCRIPTION_FAIL: 'INITIALIZE_PAYSTACK_SUBSCRIPTION_FAIL',
    VERIFY_PAYSTACK_SUBSCRIPTION: 'VERIFY_PAYSTACK_SUBSCRIPTION',
    VERIFY_PAYSTACK_SUBSCRIPTION_SUCCESS: 'VERIFY_PAYSTACK_SUBSCRIPTION_SUCCESS',
    VERIFY_PAYSTACK_SUBSCRIPTION_FAIL: 'VERIFY_PAYSTACK_SUBSCRIPTION_FAIL',
    INITIALIZE_FLUTTERWAVE_SUBSCRIPTION: 'INITIALIZE_FLUTTERWAVE_SUBSCRIPTION',
    INITIALIZE_FLUTTERWAVE_SUBSCRIPTION_SUCCESS: 'INITIALIZE_FLUTTERWAVE_SUBSCRIPTION_SUCCESS',
    INITIALIZE_FLUTTERWAVE_SUBSCRIPTION_FAIL: 'INITIALIZE_FLUTTERWAVE_SUBSCRIPTION_FAIL',
    VERIFY_FLUTTERWAVE_SUBSCRIPTION: 'VERIFY_FLUTTERWAVE_SUBSCRIPTION',
    VERIFY_FLUTTERWAVE_SUBSCRIPTION_SUCCESS: 'VERIFY_FLUTTERWAVE_SUBSCRIPTION_SUCCESS',
    VERIFY_FLUTTERWAVE_SUBSCRIPTION_FAIL: 'VERIFY_FLUTTERWAVE_SUBSCRIPTION_FAIL',
    ACTIVATE_CREATOR_SUBSCRIPTION: 'ACTIVATE_CREATOR_SUBSCRIPTION',
    ACTIVATE_CREATOR_SUBSCRIPTION_SUCCESS: 'ACTIVATE_CREATOR_SUBSCRIPTION_SUCCESS',
    ACTIVATE_CREATOR_SUBSCRIPTION_FAIL: 'ACTIVATE_CREATOR_SUBSCRIPTION_FAIL',

    FETCH_ADMIN_CREATOR_GRANT_PLANS: 'FETCH_ADMIN_CREATOR_GRANT_PLANS',
    FETCH_ADMIN_CREATOR_GRANT_PLANS_SUCCESS: 'FETCH_ADMIN_CREATOR_GRANT_PLANS_SUCCESS',
    FETCH_ADMIN_CREATOR_GRANT_PLANS_FAIL: 'FETCH_ADMIN_CREATOR_GRANT_PLANS_FAIL',
    GRANT_CREATOR_SUBSCRIPTION_ADMIN: 'GRANT_CREATOR_SUBSCRIPTION_ADMIN',
    GRANT_CREATOR_SUBSCRIPTION_ADMIN_SUCCESS: 'GRANT_CREATOR_SUBSCRIPTION_ADMIN_SUCCESS',
    GRANT_CREATOR_SUBSCRIPTION_ADMIN_FAIL: 'GRANT_CREATOR_SUBSCRIPTION_ADMIN_FAIL',
    CLEAR_ADMIN_CREATOR_GRANT: 'CLEAR_ADMIN_CREATOR_GRANT',
};

export interface ISubscriptionPlanInitialState {
    subscriptionPlans: ISubscriptionPlan[];
    fetchingSubscriptionPlans: boolean;
    fetchingSubscriptionPlansError: any;
    loggedInUserPlan?: ISubscriptionPlan;
    fetchingLoggedInUserPlan: boolean;
    /** True after get-my-plan succeeds or fails (incl. users with no plan). */
    loggedInUserPlanLoaded: boolean;
    fetchingLoggedInUserPlanError: any;
    updatingUserPlan: boolean;
    updatingUserPlanError: any;
    subscribing: boolean;
    subscribeError: any;
    subscription?: ISubscriptionPlan;
    adminGrantablePlans: import('../../types/global/creatorSubscription.types').ICreatorGrantablePlan[];
    fetchingAdminGrantablePlans: boolean;
    grantingCreatorSubscription: boolean;
    adminCreatorGrantResult:
        | import('../../types/global/creatorSubscription.types').IGrantCreatorSubscriptionResult
        | null;
}

export interface ISubscriptionPlan {
    _id: string;
    name: string;
    plan_name?: string;
    amount: number;
    interval: TSubscritionInterval;
    subscription_plan: string;
    description: string;
    features: string[];
    plan_code: string;
    limit: number;
    currency: string;
    created_at: string;
    created_by: string;
    source: string;
    plan: Plan;
    preferred_plan: boolean;
    active: boolean;
    country: string;
    region: string;
    original_price: number;
    converted_amount: string;
    transaction_currency: string;
    converted_amount_no_symbol: string;
    rate?: number;
    bare_amount?: number;
    original_currency?: string;
    defaulted_to_usd?: boolean;
    formatted_for_display?: string;
    feature_limits?: FeatureLimits;
    toSymbol?: string;
    converted?: boolean;
    system_subscription?: boolean;
    /** Paystack subscription fields */
    subscription_code?: string;
    subscription_id?: string | null;
    stripe_customer_code?: string | null;
    paystack_customer_code?: string | null;
    start_date?: string | null;
    next_payment_date?: string;
    current_period_end?: string;
    status?: string;
    paid?: boolean;
    /** Optional plan doc overrides from API */
    entitlements?: Partial<import('../../utils/planEntitlements').CreatorEntitlements>;
    /** Resolved class defaults + overrides (preferred when present) */
    effective_entitlements?: import('../../utils/planEntitlements').CreatorEntitlements;
    /** One free trial per user — from plan catalog / get-my-plan */
    trial?: {
        available: boolean;
        days: number;
        already_used?: boolean;
        reason?: string | null;
        cta_label?: string | null;
        tokenize_amount_kobo?: number;
        tokenize_currency?: string;
    };
    /** Per-currency Flutterwave payment plan ids (catalog). */
    flutterwave_plan_codes?: Record<string, string>;
    subscription_details?: {
        status?: string;
        flutterwave_plan_id?: string | null;
        catalog_plan_code?: string | null;
        source?: string | null;
        payment_source?: string | null;
        flutterwave_card_token?: string | null;
        plan?: Plan;
        current_period_end?: number | string;
        is_trial?: boolean;
        trial_days?: number;
    };
    payment_provider?: string;
    /** Approved/in_progress premium campaigns at risk if plan is cancelled/downgraded */
    premium_campaign_impact?: IPremiumCampaignImpact;
}

export interface IPremiumCampaignImpactCampaign {
    participation_id: string;
    campaign_id: string;
    title: string;
    status: string;
    premium_requirements: string[];
}

export interface IPremiumCampaignImpact {
    has_approved_premium_campaigns: boolean;
    campaigns: IPremiumCampaignImpactCampaign[];
}

export type { IUpdateCreatorSubscriptionPaymentPayload } from '../../types/global/creatorSubscription.types';

export interface FeatureLimits {
    jobs: number;
    applications: number;
    voting: number;
    events: number;
    campaigns: number;
}

interface Plan {
    /** Stripe plan price ID (string) or Paystack internal plan id (number) */
    id: string | number;
    /** Paystack: human-readable plan name */
    name?: string;
    /** Paystack: plan code used to match against our plan list (e.g. PLN_xxx) */
    plan_code?: string;
    /** Paystack: plan description */
    description?: string;
    object?: string;
    active?: boolean;
    aggregate_usage?: string | null;
    amount: number;
    amount_decimal?: string;
    billing_scheme?: string;
    created?: number;
    currency?: string;
    /** Stripe uses "month"/"year"; Paystack uses "monthly"/"yearly" */
    interval: string;
    interval_count?: number;
    livemode?: boolean;
    metadata?: Record<string, any>;
    meter?: string | null;
    nickname?: string | null;
    product?: string;
    tiers?: string | null;
    tiers_mode?: string | null;
    transform_usage?: string | null;
    trial_period_days?: number | null;
    usage_type?: string;
    send_invoices?: number;
    send_sms?: number;
}

export type TSubscritionInterval = 'month' | 'year' | 'week' | 'day';

export interface IChangePayload {
    priceId: string;
    paymentMethodId?: string;
    isUpgrade?: boolean;
    /** Start the one-time 14-day creator trial (card required, no plan charge yet) */
    start_trial?: boolean;
    /** Paystack-specific fields */
    isPaystack?: boolean;
    plan?: string;
    authorization?: string;
}

export interface SubscriptionResponse {
    id: string;
    object: string;
    application: null;
    application_fee_percent: null;
    automatic_tax: {
        enabled: boolean;
        liability: null;
    };
    billing_cycle_anchor: number;
    billing_cycle_anchor_config: null;
    billing_thresholds: null;
    cancel_at: null;
    cancel_at_period_end: boolean;
    canceled_at: null;
    cancellation_details: {
        comment: null;
        feedback: null;
        reason: null;
    };
    collection_method: string;
    created: number;
    currency: string;
    current_period_end: number;
    current_period_start: number;
    subscription_id: string;
    customer: string;
    days_until_due: null;
    default_payment_method: null;
    default_source: null;
    default_tax_rates: any[];
    description: null;
    discount: null;
    discounts: any[];
    ended_at: null;
    invoice_settings: {
        account_tax_ids: null;
        issuer: {
            type: string;
        };
    };
    items: {
        object: string;
        data: Array<any>;
        has_more: boolean;
        total_count: number;
        url: string;
    };
    latest_invoice: {
        id: string;
        object: string;
        account_country: string;
        account_name: string;
        account_tax_ids: null;
        amount_due: number;
        amount_paid: number;
        amount_remaining: number;
        amount_shipping: number;
        application: null;
        application_fee_amount: null;
        attempt_count: number;
        attempted: boolean;
        auto_advance: boolean;
        automatic_tax: {
            enabled: boolean;
            liability: null;
            status: null;
        };
        automatically_finalizes_at: null;
        billing_reason: string;
        charge: null;
        collection_method: string;
        created: number;
        currency: string;
        custom_fields: null;
        customer: string;
        customer_address: null;
        customer_email: string;
        customer_name: null;
        customer_phone: null;
        customer_shipping: null;
        customer_tax_exempt: string;
        customer_tax_ids: any[];
        default_payment_method: null;
        default_source: null;
        default_tax_rates: any[];
        description: null;
        discount: null;
        discounts: any[];
        due_date: null;
        effective_at: number;
        ending_balance: number;
        footer: null;
        from_invoice: null;
        hosted_invoice_url: string;
        invoice_pdf: string;
        issuer: {
            type: string;
        };
        last_finalization_error: null;
        latest_revision: null;
        lines: {
            object: string;
            data: Array<any>;
            has_more: boolean;
            total_count: number;
            url: string;
        };
        livemode: boolean;
        metadata: Record<string, any>;
        next_payment_attempt: null;
        number: string;
        on_behalf_of: null;
        paid: boolean;
        paid_out_of_band: boolean;
        payment_intent: null;
        payment_settings: {
            default_mandate: null;
            payment_method_options: null;
            payment_method_types: null;
        };
        period_end: number;
        period_start: number;
        post_payment_credit_notes_amount: number;
        pre_payment_credit_notes_amount: number;
        quote: null;
        receipt_number: null;
        rendering: null;
        rendering_options: null;
        shipping_cost: null;
        shipping_details: null;
        starting_balance: number;
        statement_descriptor: null;
        status: string;
        status_transitions: {
            finalized_at: number;
            marked_uncollectible_at: null;
            paid_at: number;
            voided_at: null;
        };
        subscription: string;
        subscription_details: {
            metadata: Record<string, any>;
        };
        subtotal: number;
        subtotal_excluding_tax: number;
        tax: null;
        tax_percent: null;
        test_clock: null;
        total: number;
        total_discount_amounts: any[];
        total_excluding_tax: number;
        total_pretax_credit_amounts: any[];
        total_tax_amounts: any[];
        transfer_data: null;
        webhooks_delivered_at: null;
    };
    livemode: boolean;
    metadata: Record<string, any>;
    next_pending_invoice_item_invoice: null;
    on_behalf_of: null;
    pause_collection: null;
    payment_settings: {
        payment_method_options: null;
        payment_method_types: null;
        save_default_payment_method: string;
    };
    pending_invoice_item_interval: null;
    pending_setup_intent: null;
    pending_update: null;
    plan: {
        id: string;
        object: string;
        active: boolean;
        aggregate_usage: null;
        amount: number;
        amount_decimal: string;
        billing_scheme: string;
        created: number;
        currency: string;
        interval: 'month' | 'year' | 'week' | 'day';
        interval_count: number;
        livemode: boolean;
        metadata: Record<string, any>;
        meter: null;
        nickname: null;
        product: string;
        tiers: null;
        tiers_mode: null;
        transform_usage: null;
        trial_period_days: null;
        usage_type: string;
    };
    quantity: number;
    schedule: null;
    start_date: number;
    status: string;
    tax_percent: null;
    test_clock: null;
    transfer_data: null;
    trial_end: null;
    trial_settings: {
        end_behavior: {
            missing_payment_method: string;
        };
    };
    trial_start: null;
}
